import React, { lazy } from 'react';
import { mdiBook, mdiCurrencyUsd, mdiFileDocumentEditOutline } from '@mdi/js';
import { ROLE_NAMES } from 'src/util';
const MultiFamilyLoanInfo = lazy(
  () =>
    import('src/components/loanOfficer/Loan/Forms/MultiFamily/PropertyBorrower'),
);
const MultiFamilyLoanType = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/LoanType'),
);
const MultiFamilyPropertyType = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/LoanInfo'),
);
const MultiFamilySponsor = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/Sponsor'),
);
const MultiFamilyCosts = lazy(
  () =>
    import('src/components/loanOfficer/Loan/Forms/MultiFamily/SourcesAndUses'),
);
const MultiFamilyExpenses = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/Expenses'),
);
const MultiFamilyRentRoll = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/RentRoll'),
);
const MultifamilyLenders = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/Lenders'),
);
const MultiFamilySummary = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/Summary'),
);
const MultiFamilyLoanTerms = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/LoanTerms'),
);
const MultifamilySyncForm = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/SyncPage'),
);
const MultifamilyUnderwriting = lazy(
  () =>
    import('src/components/loanOfficer/Loan/Forms/MultiFamily/Underwriting'),
);
const MultifamilyClosingFee = lazy(
  () => import('src/components/loanOfficer/Loan/Forms/MultiFamily/ClosingFee'),
);

export const formSections = [
  {
    title: 'Sync Page',
    route: 'sync-multifamily',
    icon: mdiFileDocumentEditOutline,
    component: <MultifamilySyncForm />,
    requiresLoanProgram: false,
    roleFilter: [ROLE_NAMES.DEVELOPER],
  },
  {
    title: 'Loan Type',
    route: 'loan-type-multifamily',
    icon: mdiFileDocumentEditOutline,
    component: <MultiFamilyLoanType />,
    requiresLoanProgram: true,
  },
  {
    title: 'Property/Borrower Info',
    route: 'property-borrower-multifamily',
    icon: mdiFileDocumentEditOutline,
    component: <MultiFamilyLoanInfo />,
    requiresLoanProgram: true,
  },
  {
    title: 'Sponsor',
    route: 'sponsor-multifamily',
    icon: mdiFileDocumentEditOutline,
    component: <MultiFamilySponsor />,
    requiresLoanProgram: true,
  },
  {
    title: 'Loan Info',
    route: 'loan-info-multifamily',
    icon: mdiCurrencyUsd,
    component: <MultiFamilyPropertyType />,
    requiresLoanProgram: true,
  },
  {
    title: 'Loan Terms',
    route: 'loan-terms-multifamily',
    icon: mdiCurrencyUsd,
    component: <MultiFamilyLoanTerms />,
    requiresLoanProgram: true,
    sections: [
      {
        title: 'Rent Roll',
        route: 'rentroll-multifamily',
        icon: mdiCurrencyUsd,
        component: <MultiFamilyRentRoll />,
        requiresLoanProgram: true,
      },
      {
        title: 'Income & Expenses',
        route: 'expenses-multifamily',
        icon: mdiCurrencyUsd,
        component: <MultiFamilyExpenses />,
        requiresLoanProgram: true,
      },
      {
        title: 'Sources & Uses',
        route: 'costs-multifamily',
        icon: mdiCurrencyUsd,
        component: <MultiFamilyCosts />,
        requiresLoanProgram: true,
      },
      {
        title: 'Summary',
        route: 'summary-multifamily',
        icon: mdiCurrencyUsd,
        component: <MultiFamilySummary />,
        requiresLoanProgram: true,
      },
    ],
  },
  {
    title: 'Lenders',
    route: 'lenders-multifamily',
    icon: mdiFileDocumentEditOutline,
    component: <MultifamilyLenders />,
    requiresLoanProgram: true,
  },
  {
    title: 'Underwriting',
    route: 'underwriting-multifamily',
    icon: mdiBook,
    component: <MultifamilyUnderwriting />,
    requiresLoanProgram: true,
  },
  {
    title: 'Closing Fee Sheet',
    route: 'closing-fee-multifamily',
    icon: mdiFileDocumentEditOutline,
    component: <MultifamilyClosingFee />,
    requiresLoanProgram: true,
  },
];
